module.exports = __webpack_public_path__ + "media/images/user/lp/pc_mobile_icon-8144ee6ab4df66495d9c842872a8c6da.png";